import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { useFindJobState } from "../../../../data/status";
import { useLookupCode } from "../../../../data/lookup";
import Tooltip from "../../../custom-ui/tooltip/tooltip";
import { TailwindHoverEnlarge } from "../../../../util/tailwind/tailwind-styles";
import DisplayItemLookup from "../../../custom-ui/display/displayItemLookups";
import { useEmployer } from "../../../../data/employer";

const EmpJobNewListingLineComponent_NewUI =
  ({ row }: { row: any }) => {
    const { data: solution } = useLookupCode(row?.solutionType);
    const { data: statusData } = useFindJobState(row?.jobState);

    const colorJobListingVariants: any = {
      draft: "bg-instant-teams-tags-CREAM text-black",
      live: "bg-instant-teams-tags-GREEN",
      on_hold: "bg-instant-teams-tags-ROSE",
      closed_filled: "bg-instant-teams-tags-LBLUE",
      closed_cancelled: "bg-instant-teams-gray-D1",
    };

    function getExpirationMessage(
      timestamp: { seconds: number; nanoseconds: number } | null
    ): string | number | null {
      if (!timestamp || typeof timestamp.seconds !== 'number') return null;
    
      const now = Date.now(); // current UTC time in milliseconds
    
      // Convert Firestore timestamp to milliseconds
      const expirationTime =
        timestamp.seconds * 1000 + Math.floor(timestamp.nanoseconds / 1_000_000);
    
      // If the date is in the past, return null
      if (expirationTime < now) return null;
    
      const diffTime = expirationTime - now;
    
      // Format the expiration date as dd/mm/yyyy
      const date = new Date(expirationTime);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const expireDate = `${day}/${month}/${year}`;
    
      // If the date is more than 7 days in the future, return formatted date
      if (diffTime > 7 * 24 * 60 * 60 * 1000) {
        return expireDate;
      }
    
      // If within the next 7 days, return number of days remaining
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
    
    
    const expireDate:any = getExpirationMessage(row?.expirationDate)


    return (
      <Link
        to={`/jobs-new/${row?.id}/${row?.companyId}/information`}
        className="cursor-pointer bg-white h-full"
      >
        <div

          className={
            TailwindHoverEnlarge(105) +
            "items-center w-full rounded-lg relative shadow-lg pb-2 "
          }
        >
          <div className="items-center bg-instant-teams-teal-Main p-5 rounded-t-lg w-full min-h-max h-42">
          <div className="flex items-center justify-between  ">
              <div className="flex">
              <div className={` bg-white text-center  ${expireDate ? " pr-14 " : "pr-14"}  ml-[-20px]`}>
                <p className=" pl-2 py-[1px] text-[10px]">{solution?.[0]?.label || "Not Set"}</p>
              </div>
              <div className=" bg-instant-teams-teal-Main  ml-[-11px] h-5 w-5 rotate-45 ">

              </div>
              </div>
             

              {expireDate && <div className="flex">
                 <div className=" bg-instant-teams-teal-Main  mr-[-7px] h-5 w-5 rotate-45 ">
              </div>
              <div className=" bg-white w-auto pl-3  mr-[-20px]">
                {expireDate && <p className=" pl-[3px] pr-[2px] py-[1px] text-[10px]">{ !isNaN(expireDate)?`Expires in ${expireDate}  days`: expireDate?`Expires on ${expireDate}`:''}</p>}
              </div> 
              </div>}
    
            

            </div>
            <div className={`m-auto   w-16 h-16 rounded-full bg-white }`}>
                <img
                  className="object-scale-down w-16 h-16 rounded-full  resize  mt-1 my-auto"
                  src={row?.companyLogo || "/images/default-employer.jpg"}
                  alt={row?.companyFullName}
                />
              </div>

            <div className="w-full text-white pl-2 text-center mb-2">
              <p className=" text-sm">{row?.companyFullName}</p>
              <p className=" text-xl whitespace-nowrap text-ellipsis overflow-hidden">
                {row?.jobName}
              </p>
              <p className="text-xs font-thin">Number of Openings:{" "} <strong>{row?.openings || 1}</strong></p>
            </div>
          

          </div>
          <Tooltip text={statusData?.description || "Current Status"}>
            <div
              className={`items-center w-[90%]  mt-5 rounded-md text-white mx-auto p-1 ${colorJobListingVariants[statusData?.id] ||
                "bg-instant-teams-purple-Main"
                }`}
            >
              <p className="text-center">{statusData?.label}</p>
            </div>
          </Tooltip>


          <div className="flex mt-2 w-full px-3 text-instant-teams-teal-Main text-sm justify-between  items-center">
            <div className=" rounded-lg px-3 py-1  bg-gray-300">
              <DisplayItemLookup value={row?.workTerm} group={"workTerm"} />
            </div>
            <div className=" rounded-lg px-3 py-1 bg-gray-300">
              <DisplayItemLookup value={row?.workType} group={"workType"} />
            </div>
            <div className=" rounded-lg px-3 py-1 bg-gray-300">
              <DisplayItemLookup
                value={row?.workSettings}
                group={"workSetting"}
              />
            </div>

          </div>


     
          <div className="text-center text-gray-500 text-sm mt-3">
            Hours Per Week:{" "}
            {row?.hoursPerWeek ? (
              <>
                {row?.hoursPerWeek?.min} - {row?.hoursPerWeek?.max}
              </>
            ) : (
              <>Not Set</>
            )}
          </div>
          <div className="text-center text-gray-500 text-sm mt-1 mb-2">
          Salary Type:
            {row?.payRate?.type === "hourly" && <span className="ml-[2px]">Hourly</span>}
            {row?.payRate?.type === "salary" &&  <span className="ml-[2px]">Yearly</span>}
            {row?.payRate?.type === "commission" && (
              <span>Commission</span>
            )}
            {row?.payRate?.type === "unpaid_internship" && (
             <span className="ml-[2px]">Free Internship</span>
            )}
            {!["hourly", "salary", "commission", "unpaid_internship"].includes(
              row?.payRate?.type,
            ) &&  <span className="ml-[2px]">Not Set</span>}
          </div>
          <div className=" flex mt-3  justify-center">
            <hr className="w-[90%] h-[1px] bg-gray-300 "></hr>
          </div>

          <div className=" mt-3 px-6 flex justify-between">
            <div className="flex" >
              <img className="h-6 w-6 " src="/images/eyeicon-view.png" />
              <p className="text-[14px] font-bold text-gray-600">
                {row?.clicksCounter
                  || 0}
              </p>
            </div>
            <div className="flex" >
              <img className="h-7 w-7 " src="/images/clickicon.png" />
              <p className="text-[14px] font-bold text-gray-600">
                {row?.applyNowCounter
                  || 0}
              </p>
            </div>
          </div>
        </div>
      </Link>
    );
  }


export default EmpJobNewListingLineComponent_NewUI;
